import React, { useState } from "react"
import Image, { GatsbyImageProps } from "gatsby-image"
import styled from "styled-components"
import { useRenderOn } from "../../../hooks/useRenderOn"
import media from "../../../helpers/media"

interface IScreen {
  duration: number
}

const Screen = styled.div<IScreen>`
  z-index: 99;
  position: fixed;
  overflow: auto;
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  background: var(--color-light);
  cursor: pointer;
  transition: opacity ${({ duration }) => duration}s ease-in-out;

  &.end-active {
    opacity: 0;
  }
`

const Grid = styled.section`
  overflow-x: hidden;
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-gap: 10px;

  ${media.laptop} {
    grid-template-columns: repeat(2, 1fr);
  }
`

const Intro = styled.div`
  font-family: var(--font-secondary);
  font-size: 19px;
  margin: 15px 5px 0 5px;
  padding-left: 50px;
  display: none;
  max-width: 420px;

  b {
    font-family: var(--font-primary);
    font-weight: 400;
    font-size: 17px;
  }

  ${media.tablet} {
    margin: 0;
    /* font-size: 32px; */

    b {
      /* font-size: 27px; */
    }
  }

  ${media.laptop} {
    display: block;
  }
`

const ImageIntro = styled(Image)`
  height: calc(100vh - 160px);
  max-width: 80%;
  margin: auto;
  transition: opacity 0.4s ease-in-out, transform 0.4s ease-in-out;

  &:hover {
    opacity: 0.7;
    transform: scale(1.01);
  }

  ${media.mobile} {
    max-width: initial;
    height: calc(100vh - 400px);
  }
  ${media.laptop} {
    height: calc(100vh - 150px);
    max-width: 370px;
    margin-left: 0;
  }
`

const Logo = styled.div`
  top: 0;
  left: 0;

  font-family: var(--font-primary);

  color: var(--color-dark);
  text-transform: lowercase;
  transition: opacity 0.4s ease-in-out;

  font-size: 22px;
  padding: 20px;
  line-height: 1;

  ${media.mobile} {
    padding: 30px 50px;
    font-size: 52px;
    line-height: 1.5;
  }

  ${media.laptop} {
    padding-bottom: 10px;
  }

  &:hover {
    opacity: 0.7;
  }
`

const Link = styled.div``

const MobileLinks = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 260px;
  padding: 0 20px 20px 20px;
  text-align: left;
  margin: auto;

  ${Link} {
    color: var(--color-dark);
    font-size: var(--font-size-xl);
    white-space: nowrap;

    &:hover {
      opacity: 0.7;
    }
  }

  ${media.laptop} {
    display: none;
  }
`

const addEventParam = () => {
  typeof window !== "undefined" &&
    window.history.replaceState({}, "", "?que-pense-georges")
}

interface IProps {
  image?: GatsbyImageProps
  intro1?: string
  logo: string
  closeIntro: () => void
}

const WaitingScreen = ({
  image,
  intro1 = "",
  logo,
  closeIntro,
}: IProps): JSX.Element => {
  const duration = 0.5
  const [endAnimation, startEndAnimation] = useState<boolean>(false)

  const handleClick = () => {
    startEndAnimation(true)

    setTimeout(() => {
      closeIntro()
    }, duration * 1000)
  }

  return (
    <Screen
      onClick={handleClick}
      className={endAnimation ? "end-active" : undefined}
      duration={duration}
    >
      <Logo>{logo}</Logo>
      <Grid>
        <div>
          <MobileLinks>
            <Link>que fait georges ?</Link>
            <Link onClick={addEventParam}>que pense georges ?</Link>
          </MobileLinks>
          <Intro
            dangerouslySetInnerHTML={{
              __html: intro1,
            }}
          />
        </div>
        <div>
          {image && (
            <ImageIntro
              fluid={image.fluid}
              alt="Atelier Georges"
              imgStyle={{
                objectFit: "contain",
              }}
            />
          )}
        </div>
      </Grid>
    </Screen>
  )
}

export default WaitingScreen
